import React from 'react';
import {connect} from 'react-redux';

import {TypeSat} from 'topmeteo/general/constants';

import {
    getNextImage,
    getNextOffset,
    getPreviousImage,
    getPreviousOffset,
} from 'topmeteo/general/selectors';

import Button from './ChangeImageButton';

const PreviousDate = {key: 'previous-date', label: '-24', action: getPreviousOffset};
const PreviousIndex = {key: 'previous-index', label: '-h', action: getPreviousImage};
const NextIndex = {key: 'next-index', label: '+h', action: getNextImage};
const NextDate = {key: 'next-date', label: '+24', action: getNextOffset};

const getButtons = (type, resolution) => {
    if (type === TypeSat) {
        const name = resolution === 60 ? 'h' : String(resolution);

        return [
            {...PreviousIndex, label: `-${name}`},
            {...NextIndex, label: `+${name}`},
        ];
    }

    return [
        PreviousDate,
        PreviousIndex,
        NextIndex,
        NextDate,
    ];
};

const TypedButtons = ({type, resolution}) => (
    <div>{getButtons(type, resolution).map(props => <Button {...props} showLabel />)}</div>
);

const mapStateToProps = ({resolution}) => ({resolution});

export default connect(mapStateToProps)(TypedButtons);
